import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, watch } from 'vue';

interface IProps {
  value: string;
  baseData: any;
  change: (value: string[]) => void;
  submitValue:(value: string[]) => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'SpecialPolicyApplication',
  props: {
    value: null,
    baseData: null,
    change: null,
    submitValue: null
  },
  setup(__props: any) {

const props = __props as { value: string, baseData: any, change: (value: string[]) => void, submitValue:(value: string[]) => void }


const currentValue = ref<string>('');
watch(() => props.value, () => {
    currentValue.value = props.value
})
const handleSelectChange = (e: any) => {
  props.change(e);
  props.submitValue(e);
};

return (_ctx: any,_cache: any) => {
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createBlock(_component_a_select, {
    class: "oio-select",
    "dropdown-class-name": "oio-select-dropdown",
    value: currentValue.value,
    "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((currentValue).value = $event)),
    placeholder: "请选择促销类型",
    allowClear: "",
    defaultActiveFirstOption: false,
    options: __props.baseData.promotionTypeEnumList,
    disabled: __props.baseData.disabled,
    onChange: handleSelectChange
  }, null, 8, ["value", "options", "disabled"]))
}
}

})